import React, { PureComponent } from 'react'
import uuidv4 from 'uuid/v4'
import ExpandableList from '~/components/ExpandableList'
import ebookIcon from '~/assets/icon-ebook.svg'
import Item from './item'

export default class EBook extends PureComponent {
  renderItem = (itemData, handleClick) => {
    return (
      <Item
        key={`item-${uuidv4()}`}
        itemData={itemData}
        handleClick={handleClick}
      />
    )
  }
  render() {
    const moduleListConfig = {
      icon: ebookIcon,
      headerText: '电子书',
      renderItem: this.renderItem,
      listData: this.props.ebookData,
    }
    return <ExpandableList {...moduleListConfig} />
  }
}



// WEBPACK FOOTER //
// ./src/modules/E-Book/index.js